export function CurrencyInput(value: string) {
    if (!value) return '';
    if (value==='0' || value==="." || value.length===0) return '';
    var cleanValue = "";
    var formatted = value.replace(/[^\d.]/g, '')
                        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                        .replace(/\.([.\d]+)$/, function(m, m1) {
                            return '.' + m1.replace(/\./g, '')}
                        );
    // Input Validation                    
    if(formatted.includes(".")){
        var num = formatted.split('.');
        var integer = num[0]
        var decimal = num[1];
        if(integer.length < 11){
            if(decimal.length>2){
                cleanValue = `${integer}.${decimal.substring(0,2)}`;
            } else {
                cleanValue = formatted;
            }
        } else {
            integer = integer.replace(/[^\d]/g, '').substring(0,8)
            var val = integer.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            if(decimal.length>2){
                cleanValue = `${val}.${decimal.substring(0,2)}`;
            } else {
                cleanValue = `${val}.${decimal}`;
            }
        }
    } else if(formatted.length>10){
        cleanValue = formatted.substring(0,10)
                            .replace(/[^\d.]/g, '')
                            .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    } else {
        cleanValue = formatted;
    }
    return cleanValue;
}
